import Api from "./base/api-base";

export default class CategoryApi {
  list() {
    return Api.get({
      endpoint: Api.endpoint.category
    });
  }

  store(params) {
    return Api.post({
      endpoint: Api.endpoint.category,
      params: params
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.category,
      id: id
    });
  }
  
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.category,
      id: id,
      params: params
    });
  }

  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.category,
      id: id
    });
  }
}
